// extracted by mini-css-extract-plugin
export default {"wrapper":"dp-z","response":"ep-z","error":"fp-z","disabled":"gp-z","buttons":"hp-z","feedbackQuestionSection":"ip-z","yesNoWrapper":"jp-z"};